module.exports = __webpack_public_path__ + "img/set_sms.2cc8e1f5.svg";